import SeoHead from "@/components/SeoHead";
import Hero from "@/sections/Hero";
import TrustedLogos from "@/components/TrustedLogos";
import CategoryExplorer from "@/sections/CategoryExplorer";
import FeaturedCoursePathways from "@/sections/FeaturedCoursePathways";
import LearningFormats from "@/sections/LearningFormats";
import WhyZaranTech from "@/sections/WhyZaranTech";
import CorporateTrainingPreview from "@/sections/CorporateTrainingPreview";
import OutcomesJourney from "@/sections/OutcomesJourney";
import SocialProof from "@/sections/SocialProof";
import ReviewsSection from "@/sections/ReviewsSection";
import BlogTeaser from "@/sections/BlogTeaser";
import SeoContent from "@/sections/SeoContent";
import FaqSection from "@/sections/FaqSection";
import FinalConversion from "@/sections/FinalConversion";
import { PAGES } from "@/constants/testIds";
import { buildFaqSchema } from "@/seo/seoService";
import { FAQS } from "@/data/faqs";

export default function HomePage() {
  return (
    <div data-testid={PAGES.home}>
      <SeoHead
        title="Global IT Training in SAP, Workday & AI | ZaranTech"
        description="ZaranTech delivers live, self-paced, and corporate IT training in SAP, Workday, and AI. Trusted by 350+ corporate clients across 37+ countries."
        keywords="IT training, SAP training, Workday training, AI training, Microsoft Copilot training, corporate IT training, online instructor-led training, professional certification training"
        path="/"
        schemas={[{ id: "home-faq-schema", data: buildFaqSchema(FAQS) }]}
      />
      <Hero />
      <section className="border-b border-line bg-white">
        <div className="mx-auto max-w-[1440px] px-5 lg:px-10 py-10">
          <TrustedLogos variant="marquee" />
        </div>
      </section>
      <div className="zt-content-section"><CategoryExplorer /></div>
      <div className="zt-content-section"><FeaturedCoursePathways /></div>
      <div className="zt-content-section"><LearningFormats /></div>
      <div className="zt-content-section"><WhyZaranTech /></div>
      <div className="zt-content-section"><CorporateTrainingPreview badgeLabel="05 · Corporate training" /></div>
      <div className="zt-content-section"><OutcomesJourney /></div>
      {/* SocialProof ("07 . What learners look for") hidden for now as per requirement. Keep component for later re-enable. */}
      {/* <div className="zt-content-section"><SocialProof /></div> */}
      <div className="zt-content-section"><ReviewsSection maxWidthClass="max-w-[1440px]" cardsPerRow={4} className="relative py-6 lg:py-8 bg-bg-alt overflow-hidden" /></div>
      <div className="zt-content-section"><BlogTeaser /></div>
      {/* ExploreTrainingSection (SeoContent, "08 . Explore Training") hidden for now as per requirement. Keep component for future SEO/content expansion. */}
      {/* <SeoContent /> */}
      <div className="zt-content-section"><FaqSection maxWidthClass="max-w-[1440px]" paddingClass="py-6 lg:py-8" /></div>
      <div className="zt-content-section"><FinalConversion /></div>
    </div>
  );
}
